import React, {useState, useEffect} from "react";
import { Link } from "react-router-dom";
import DeleteModal from "../../../../components/modelpopup/DeleteModal";
import RolesPermissionsModal from "../../../../components/modelpopup/RolesPermissionsModal";
import Breadcrumbs from "../../../../components/Breadcrumbs";

import { getRolesApi , getPermissionsApi, updatePermissionsApi} from "api/services/roles";
import { Button } from "components/Button";
import {  toast, Bounce } from 'react-toastify';

const RolesPermissions = () => {
 
  // const roles = [
  //   "Administrator",
  //   "CEO",
  //   "Manager",
  //   "Team Leader",
  //   "Accountant",
  //   "Web Developer",
  //   "Web Designer",
  //   "HR",
  //   "UI/UX Developer",
  //   "SEO Analyst",
  // ];



  const [roles, setRoles] = useState([])
  const [permissions, setPermissions] = useState([])

  const [selectedRole, setSelectedRole] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(()=>{
    
    getPermissionsApi().then(response=>{
     
      setPermissions(response.data)
    })
    fetchRole()
  },[])

  const fetchRole = () => {
    getRolesApi().then(response=>{
      let all_roles = response?.data?.results?.map(item=> {
        return {
          ...item,
          permissions: item?.permissions.map(p_item=> {
            return {...p_item,enabled: true}
          })
        }
      })
      setRoles(all_roles)
    })
  }

  const  changePermission = (e, index) => {
    let selected = {...selectedRole}
    selected.permissions[index].enabled = e.target.checked
    setSelectedRole(selected)
  }
  const setRole = (role) => {
    
    let _selected = {...role}
    const map = new Map();

  [...permissions, ..._selected?.permissions].forEach(item => {
    map.set(item.id, item); // Keeps only the latest entry by id
  });
  _selected.permissions = Array.from(map.values())


    setSelectedRole(_selected)
  }

  const updatePermissions = () => {
    setLoading(true)
    let _selected = {access_scope: selectedRole?.access_scope, is_manager: selectedRole?.is_manager}
    
    
    let selected_permissions = selectedRole.permissions?.filter(item=> item.enabled).map(item=> item.id)
    _selected.permissions = selected_permissions
    updatePermissionsApi(selectedRole?.id, _selected).then(response=>{
      fetchRole()
      setLoading(false)
      toast.success('Permissions updated!', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
        });

    }).catch(e=>{
      setLoading(false)
      toast.error('Error updating Permissions !', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
        });
    })
  }
  return (
    <>
      <div className="page-wrapper">
        {/* Page Content */}
        <div className="content container-fluid">
          {/* Page Header */}
          <Breadcrumbs maintitle="Roles & Permissions" />

          {/* /Page Header */}
          <div className="row">
            <div className="col-sm-4 col-md-4 col-lg-4 col-xl-3">
              {/* <Link
                to="#"
                className="btn btn-primary btn-block w-100"
                data-bs-toggle="modal"
                data-bs-target="#add_role"
              >
                <i className="fa fa-plus" /> Add Roles
              </Link> */}
              <div className="roles-menu">
                <ul>
                  {roles.map((role, index) => (
                    <li key={index} className={selectedRole?.id === role?.id ? "active" : ""}>
                      <Link to="#" onClick={()=> setRole(role)} >
                        {role?.name}
                        {/* <span className="role-action">
                          <span
                            className="action-circle large me-1"
                            data-bs-toggle="modal"
                            data-bs-target="#edit_role"
                          >
                            <i className="material-icons">edit</i>
                          </span>
                          <span
                            className="action-circle large delete-btn"
                            data-bs-toggle="modal"
                            data-bs-target="#delete"
                          >
                            <i className="material-icons">delete</i>
                          </span>
                        </span> */}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="col-sm-8 col-md-8 col-lg-8 col-xl-9">
              <div className="d-flex justify-content-between  m-b-20" >
                <div className="col-10 d-flex align-items-end" ><h6 className="card-title  ">Module Access</h6></div>
              
                {
                  selectedRole &&
                  <Button
                  label="Update"
                  disabled={loading || !selectedRole?.can_update_permissions}
                  loading={loading}
                  // to="#"
                  className="btn btn-primary btn-block w-100 "
                  // data-bs-toggle="modal"
                  // data-bs-target="#add_role"
                  onClick={updatePermissions}

                />
                  
                }
            
              </div>
              <div className="m-b-30">
              
                <ul className="list-group notification-list">
                  {selectedRole?.permissions?.map((item, index) => (
                    <li key={item.id} className="list-group-item">
                      {item.name}
                      <div className="status-toggle">
                        <input
                        disabled={!selectedRole?.can_update_permissions}
                          type="checkbox"
                          id={item.id}
                          className="check"
                          checked={item.enabled}
                          onClick={(e)=> changePermission(e, index)}
                        />
                        <label htmlFor={item.id} className="checktoggle">
                          checkbox
                        </label>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
              {/* <div className="table-responsive">
                <table className="table table-striped custom-table">
                  <thead>
                    <tr>
                      <th>Module Permission</th>
                      <th className="text-center">Read</th>
                      <th className="text-center">Write</th>
                      <th className="text-center">Create</th>
                      <th className="text-center">Delete</th>
                      <th className="text-center">Import</th>
                      <th className="text-center">Export</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData.map((categoryData, index) => (
                      <tr key={index}>
                        <td>{categoryData.category}</td>
                        {categoryData.items.map((item, itemIndex) => (
                          <td key={itemIndex} className="text-center">
                            <label className="custom_check">
                              <input type="checkbox" defaultChecked="Checked" />
                              <span className="checkmark" />
                            </label>
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div> */}
            </div>
          </div>
        </div>
        {/* /Page Content */}
        <RolesPermissionsModal />
        <DeleteModal Name="Role" />
      </div>
    </>
  );
};

export default RolesPermissions;
